//@ts-check
/** @param {Fox} fox */
module.exports = (fox) => {
	const $ = fox.jQuery;

	fox.registerWidget('Common_BottomBanner', {
		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				'embed.container': '#upgrade-promo-banner-container',
				handleDom: {
					closeBanner: {
						target: '#close-upgrade-banner',
						callback: 'closeBanner'
					},
					openMobileVersion: {
						target: '#upbs-mobile-update-open',
						callback: () => $(this.dom1('.upbs-wrapper')).addClass('opened')
					},
					hideMobileVersion: {
						target: '#pulldown-upgrade-banner',
						callback: () => $(this.dom1('.upbs-wrapper')).removeClass('opened')
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init() {
			this.showBannerPredicat = this.requireOption('showBannerPredicat');

			this.callParent('init', arguments);
		},

		addedToDom: function () {
			const shouldShow = this.showBannerPredicat();

			if (shouldShow) {
				// for smooth
				setTimeout(() => {
					if (!this.isMobile())
						$(this.dom1('.upbs-wrapper')).addClass('opened');
				}, 1000);
			}
		},

		closeBanner: function () {
			$(this.dom1('.upbs-wrapper')).removeClass('opened');

			return this.render();
		},

		isMobile: function () {
			return document.body.clientWidth <= 580;
		}
	});
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/common/widget/BottomBanner.es.js